const lang = {
    ja: {
        'productRegister.pageTitle': '展示商品登録',
        'productRegister.mediaTitle': 'メディアタイトル',
        'productRegister.productImage': '商品イメージ',
        'productRegister.productName': '商品名',
        'productRegister.productNameJP': '商品名（和文）',
        'productRegister.productNameEN': '商品名（英文）',
        'productRegister.productDescription': '商品説明',
        'productRegister.productDescriptionJP': '商品説明（和文）',
        'productRegister.productDescriptionEN': '商品説明（英文）',
        'productRegister.productAvailableProduct': '合計数量',
        'productRegister.purchaseLink': '商品購入',
        'productRegister.externalLink': '担当者と直接相談',
        'productRegister.productDocumentation': '資料アップロード',
        'productRegister.documentRequestReception': '資料請求',
        'productRegister.survey': 'アンケート',
        'productRegister.businessContact': '買いたい・商談／お問合わせ',
        'productRegister.externalLink2': '喫茶掲示板ルーム',
        'productRegister.externalLink3': '外部リンク',
        'productRegister.businessCard': '名刺交換',
        'productUpdate.pageTitle': '展示商品編集',
        'productDetails.pageTitle': '展示商品詳細',

        // new cr 19/01/2021
        'productRegister.businessContactNewText': '商談／お問合せ',
    },
    en: {

        'productRegister.pageTitle': '展示商品登録',
        'productRegister.mediaTitle': 'メディアタイトル',
        'productRegister.productImage': '商品イメージ',
        'productRegister.productName': 'Product name',
        'productRegister.productNameJP': '商品名（和文）',
        'productRegister.productNameEN': '商品名（英文）',
        'productRegister.productDescription': '商品説明',
        'productRegister.productDescriptionJP': '商品説明（和文）',
        'productRegister.productDescriptionEN': '商品説明（英文）',
        'productRegister.productAvailableProduct': '合計数量',
        'productRegister.purchaseLink': 'Buy products',
        'productRegister.externalLink': 'Talk in person',
        'productRegister.productDocumentation': '資料アップロード',
        'productRegister.documentRequestReception': 'Request for brochure',
        'productRegister.survey': 'Questionnaire',
        'productRegister.businessContact': '買いたい・商談／お問合わせ',
        'productRegister.externalLink2': '喫茶掲示板ルーム',
        'productRegister.externalLink3': 'External links',
        'productRegister.businessCard': 'Business card exchange',
        'productUpdate.pageTitle': '展示商品編集',
        'productDetails.pageTitle': '展示商品詳細',

        // new cr 19/01/2021
        'productRegister.businessContactNewText': 'Business meeting/Contact',
    },
};

export default lang;
